export type CommerceAnalyticsEvent = 'app_open' | 'landing_view' | 'activation_start' | 'activation_done' | 'add_to_cart' | 'checkout_started' | 'order_paid' | 'claim_opened' | 'partner_landing_view' | 'capital_previewed' | 'opportunity_planned';

const sessionKey = 'ca-anonymous-session';

function sessionId(): string {
  const existing = sessionStorage.getItem(sessionKey);
  if (existing) return existing;
  const created = crypto.randomUUID();
  sessionStorage.setItem(sessionKey, created);
  return created;
}

export function track(eventName: CommerceAnalyticsEvent, properties: Record<string, string | number | boolean | null> = {}): void {
  const body = JSON.stringify({ eventId: crypto.randomUUID(), sessionId: sessionId(), eventName, path: location.pathname, properties, occurredAt: new Date().toISOString() });
  void fetch('/api/events', { method: 'POST', headers: { 'content-type': 'application/json' }, body, credentials: 'omit', keepalive: true }).catch(() => undefined);
}
